import styled from 'styled-components';
import { MAX_WRAPPER_SIZE } from '../../../../settings';

export default {
    CreditContainer: styled.div.attrs({ className: 'credit-container' })`
        max-width: ${MAX_WRAPPER_SIZE};
        margin: 0 24px ${({ base }) => base ? 0 : '32px'};
        border-bottom: ${({ base }) => base ? 'none' : '1px solid #B9C0C2'};
        border-top: 1px solid #B9C0C2;
        position: relative;

        @media (min-width: 600px) {
            margin: 0 8px ${({ base }) => base ? 0 : '32px'};
        }
        
        @media (min-width: 900px) {
            margin: 0 0px  ;
        }

    `,
    DropdownMenu: styled.div.attrs({ className: 'dropdown-menu' })`
        max-height: 1px;
        overflow: hidden;
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-direction: column;
        transition: all .2s ease-in-out;
        box-sizing: border-box;
        padding: 0;
        opacity: 0;

        &.full-height {
            padding: 30px 0;
            max-height: 100vh;
            opacity: 1;
            transition: all .2s ease-in-out;
            @media(min-width: 901px){
                padding: 42px 24px 0;
            }
            @media (min-width: 999px) {
                max-height: 467px;
            }
            @media (min-width: 1200px) {
                margin-bottom: -15px;
            }
            @media (min-width: 1220px) {
                max-height: ${props => props.isLoadedFrame && props.isLoadedFrame === true ? 'auto' : '291px'};
                padding-left: 0;
                padding-right: 0;
            }
        }

        @media (min-width: 600px) {
            display: grid;
            grid-gap: 0;
            grid-template-columns: repeat(1, 1fr);
        }
        @media (min-width: 900px) {
            grid-template-columns: repeat(2, 1fr);
        }
        
        ${({ base }) => !base && `
            @media (min-width: 1220px) {
                grid-template-columns: repeat(3, 1fr);
                  padding-left: 0;
                  padding-right: 0;
            }
        `}
    `,
    DropdownButton: styled.button.attrs({ className: 'mobile-header' })`
        width: 100%;
        height: 88px;
        position: relative;
        padding: 17px 17px 17px 0;
        border: none;
        outline: none;
        border-bottom: ${props => props.isOpen ? '1px solid #B9C0C2' : 'none'};
        background: white;
        text-transform: uppercase;

        @media (min-width: 900px) {
            display: none;
        }
    `,
    MobileHeaderTitle: styled.div.attrs({ className: 'title' })`
        font-family: NobelWGL,Helvetica,Arial,OpenSans,sans-serif;
        font-size: 14px;
        line-height: 32px;
        text-align: left;
        color: #1A1A1A;
    `,
    MobileHeaderArrow: styled.img.attrs({ className: 'arrow' })`
        position: absolute;
        top: calc(50% - 4px);
        right: 10px;
        transform: ${props => props.isOpen ? 'rotate(180deg)' : 'rotate(0deg)'};
        transition: transform 0.5s ease;
    `,
    UserMessageStyle: styled.div`
        margin: 25px auto;
        font-family: Noto Sans,sans-serif;
        font-size: 18px;
        line-height: 30px;
        color: #202020;
        text-align: left;
        width: 90%;
        padding: 15px;
        @media (min-width: 700px) {
            margin: 0;
            padding: 0;
            margin-bottom: 50px;
        }
    `,
};
